import React, { useEffect } from 'react';
import { Layout, Spin } from 'antd';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { LOGIN_ROUTE } from '../../routers/route-names';
import { logoutAction } from '../login/store/actions';
import layoutClasses from '../../styles/layout.module.less';
import { loginSelector } from '../login/store/selectors';

export const Logout: React.FC = function Logout() {
  const dispatch = useDispatch();
  const { tenantId, user } = useSelector(loginSelector);

  const isLogoutFinished = !user;
  const isTenantIdStored = !!tenantId;

  useEffect(() => {
    dispatch(logoutAction.request());
  }, [dispatch]);

  return (
    <Layout
      data-testid="logout"
      className={clsx(
        layoutClasses.mainContainer,
        layoutClasses.centeredContent,
      )}
    >
      <Spin />
      {isTenantIdStored && isLogoutFinished && (
        <Redirect to={`${LOGIN_ROUTE}?tenantId=${tenantId}`} />
      )}
    </Layout>
  );
};

export default Logout;
